import { GetProjectForm } from "../../../modules/form/GetProjectForm";
/**
 * @description Class that manages the storage of UTM parameters in sessionStorage.
 */
export class LoadUTM {
    constructor(formState) {
        this.formState = formState;
        this.projectForm = new GetProjectForm(formState);
    }
    /**
    * Method that saves the UTM parameters to sessionStorage if they are not already stored.
    * Extracts the parameters from the current URL and saves them in sessionStorage for later use.
    */
    saveUtmParams() {
        sessionStorage.removeItem('urlUtm');
        let url = window.location.search;
        let urlParams = new URLSearchParams(url);
        let utm_source = urlParams.get("utm_source") ? urlParams.get("utm_source") : '';
        let utm_medium = urlParams.get("utm_medium") ? urlParams.get("utm_medium") : '';
        let utm_campaign = urlParams.get("utm_campaign") ? urlParams.get("utm_campaign") : '';
        let utm_content = urlParams.get("utm_content") ? urlParams.get("utm_content") : '';
        this.projectForm.getProductOfert(urlParams.get("ofert") || '');
        this.projectForm.getOrigen(utm_source || '');
        this.formState.manageState('utm_source', utm_source);
        this.formState.manageState('utm_medium', utm_medium);
        this.formState.manageState('utm_campaign', utm_campaign);
        this.formState.manageState('utm_content', utm_content);
        if (!sessionStorage.getItem('utm_source')) {
            sessionStorage.setItem("utm_source", utm_source || '');
        }
        if (!sessionStorage.getItem('utm_medium')) {
            sessionStorage.setItem("utm_medium", utm_medium || '');
        }
        if (!sessionStorage.getItem('utm_campaign')) {
            sessionStorage.setItem("utm_campaign", utm_campaign || '');
        }
        if (!sessionStorage.getItem('utm_content')) {
            sessionStorage.setItem("utm_content", utm_content || '');
        }
    }
}
